import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { AppComponent } from "./app.component";
import { ApploginComponent } from "./applogin/applogin.component";
import { IndexComponent } from "./index/index.component";
import { AppRoutingModule } from ".//app-routing.module";
import { UserService } from "./services/user.service";
import { KycserviceService } from "./services/kycservice.service";
import { RoutingstateService } from "./services/routingstate.service";
import { PuserserviceService } from "./services/puserservice.service";
import { AssetsService } from "./services/assets.service";
import { PagerserviceService } from "./services/pagerservice.service";
import { WalletsService } from "./services/wallets.service";
import { BankService } from "./services/bank.service";
import { HttpClientModule } from "@angular/common/http";
import { AppcustomerlistComponent } from "./appcustomerlist/appcustomerlist.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SimpleNotificationsModule } from "angular2-notifications";
import { AppkycdetailsComponent } from "./appkycdetails/appkycdetails.component";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { TransactionService } from "./services/transaction.service";
import { TransactionsComponent } from "./transactions/transactions.component";
import { FiatTransactionsComponent } from "./fiattransactions/transactions.component";
import { ClipboardModule } from "ngx-clipboard";
import { LoginactivityComponent } from "./loginactivity/loginactivity.component";
import { AdminTransactionsComponent } from "./admin-transactions/admin-transactions.component";

import { ConfigurationService } from "./services/configuration.service";

import { WithdrawComponent } from "./withdraw/withdraw.component";
import { FiatWithdrawComponent } from "./fiatwithdraw/fiatwithdraw.component";
import { OrderComponent } from "./order/order.component";
import { ExchangeService } from "./services/exchange.service";
import { TradingService } from "./services/trading.service";
import { Ng2TelInputModule } from "ng2-tel-input";
import { ManageadminComponent } from "./manageadmin/manageadmin.component";
import { AdminService } from "./services/admin.service";
import { GroupsComponent } from "./groups/groups.component";
import { SidebarComponent } from "./_layout/sidebar/sidebar.component";
import { HeaderComponent } from "./_layout/header/header.component";
import { ContentComponent } from "./_layout/content/content.component";
import { MobilesidebarComponent } from "./_layout/mobilesidebar/mobilesidebar.component";
import { AnnouncementComponent } from "./announcement/announcement.component";
import { AnnouncementService } from "./services/announcement.service";
import { Globals } from "./app-globals";
import { TradereportComponent } from "./tradereport/tradereport.component";
import { ReportService } from "./services/report.service";
import { AngularDateTimePickerModule } from "angular2-datetimepicker";
import { SecuirtiesComponent } from "./secuirties/secuirties.component";
import { MenupermissionPipe } from "./custompipes/menupermission.pipe";
import { KycplansComponent } from "./kycplans/kycplans.component";
import { SumValuesPipe } from "./custompipes/sum-values.pipe";
import { RECAPTCHA_SETTINGS, RecaptchaModule } from "ng-recaptcha";
import { environment } from "../environments/environment";
import { RecaptchaFormsModule } from "ng-recaptcha/forms";
import { FileService } from "./services/file.service";
import { RichTextEditorAllModule } from "@syncfusion/ej2-angular-richtexteditor";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { TransferComponent } from "./transfer/transfer.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { MaterialModule } from "./material/material.module";
import { ViewsService } from "./services/views.service";
import { ManageAuctionConfigurationComponent } from './manage-auction-configuration/manage-auction-configuration.component'
import { AdmintradereportComponent } from './admintradereport/admintradereport.component';
import { ManageipComponent } from './manageip/manageip.component';
import { CmsComponent } from './cms/cms.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { GeneratePasswordComponent } from './generate-password/generate-password.component';
import { LinkexpireComponent } from './linkexpire/linkexpire.component';
import { ManualkycComponent } from './manualkyc/manualkyc.component';
import { ReferralconfigComponent } from './referralconfig/referralconfig.component';
import { ReferalhistoryComponent } from './referalhistory/referalhistory.component';
import { ReferralbonustransComponent } from './referralbonustrans/referralbonustrans.component';
import { CareersComponent } from './careers/careers.component';
import { CareerService } from "./careers/career.service";
import { ContentManagementComponent } from './content-management/content-management.component';
import { ContentManagementService } from "./content-management/content-management.service";
import { CandidatesComponent } from './candidates/candidates.component';
import { ManageAddressWhitelistComponent } from './manage-address-whitelist/manage-address-whitelist.component';
import { HomeComponent } from './home/home.component';
import { HomeService } from "./home/home.service";
import { AppKycDetailsService } from "./appkycdetails/appkycdetails.service";
import { LedgerComponent } from "./ledger/ledger.component";
import { AppCustomerService } from "./appcustomerlist/appcustomer.service";
import { ClientOrderReportComponent } from "./clientorderreport/clientorderreport.component";
import { MatAutocompleteModule, MatButtonModule, MatCardModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSlideToggleModule, MatSortModule, MatTableModule, MatTooltipModule } from "@angular/material";
import { ClientOrderService } from "./clientorderreport/clientorderreport.service";

import { AdminTradeMasterReportComponent } from "./admintrademaster/admintrademaster.component";
import { EditAdminTradeMasterDialog } from "./admintrademaster/edit-admin-trade-master/edit-admin-trade-master.component";

import { ClientTradeReportComponent } from "./clienttradereport/clienttradereport.component";
import { FireblockVaultComponent } from "./fireblockvault/fireblockvault.component";
import { FireblockService } from "./fireblockvault/fireblockvault.service";
import { FireblockAuditComponent } from "./fireblockaudit/fireblockaudit.component";
import { ExchangeTradeReportComponent } from "./exchangetradereport/exchangetradereport.component";
import { PositionBookComponent } from "./positionbook/positionbook.component";
import { ClearJunctionAuditComponent } from "./clearjunctionaudit/clearjunctionaudit.component";
import { ProperJsonDialogComponent } from "./properJsonDialog/properjsondialog.component";
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { whitelistedAddressComponent } from "./whitelistedAddress/whitelistedaddress.component";
import { depositAddressComponent } from "./deposit-address/deposit-address.component";
import { AddClientTrade } from "./addclienttrade/addclienttrade.component";
import { AddExchangeTrade } from "./addexchangetrade/addexchangetrade.component";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { GetinTouchReportComponent } from "./getintouch/getintouch.component";
import { ClearJunctionTransactionsComponent } from "./clearjunctiontransactions/clearjunctiontransaction.component";
import { ClearJunctionService } from "./services/clearjunction.service";
import { EditClearJTransactions } from "./editclearJtransactions/editclearJtransactions.component";
import { FireblockTransactionsComponent } from "./fireblocktransactions/fireblocktransactions.component";
import { FireblockSyncComponent } from "./fireblocksync/fireblocksync.component";
import { FiatWithdrawRejectDialog } from "./fiatrejectconfirm/fiatwithdrawrejectconfirm.component";
import { FiatDepositConfirmDialog } from "./fiatdepositconfirmdialog/fiatdepositconfirmdialog.component";
import { ExchangeDepositComponent } from "./exchangedeposit/exchangedeposit.component";
import { ExchangeWithdrawalComponent } from "./exchangewithdrawal/exchangewithdrawal.component";
import { CustomerListComponent } from "./customerlist/customerlist.component";
import { AddEditCustomers } from "./addeditcustomer/addeditcustomer.component";
import { SidebarSubmenuComponent } from "./sidebar-submenu/sidebar-submenu.component";
import { AddEditSubmenuComponent } from "./addeditsubmenu/addeditsubmenu.component";
import { WalletComponent } from "./wallet/wallet.component";
import { BankComponent } from "./bank/bank.component";
import { AddBankDialog } from "./bank/addbank/addbank.component";
import { AddEditAdminlist } from "./addeditadminlist/addeditadminlist.component";
import { MarketPricesComponent } from "./marketprices/marketprices.component";
import { CollateralDepositComponent } from "./collateral-deposit/collateral-deposit.component";
import { EditCollateralDepositDialog } from "./collateral-deposit/edit-collateral-deposit/edit-collateral-deposit.component";
import { MultiplierDialog } from "./collateral-deposit/multiplier/multiplier.component";
import { SumsubAuditComponent } from "./sumsubaudit/sumsubaudit.component";
import { ClientAssetReportComponent } from "./clientassetreport/clientassetreport.component";
import { AddExchangeWithdrawal } from "./exchangewithdrawal/addexchangewithdrawal/addexchangewithdrawal.component";
import { AMLBotAuditComponent } from "./amlbotaudit/amlbotaudit.component";
import { AddEditMarketPrice } from "./marketprices/addeditmarketprices/addeditmarketprices.component";

import { EquitasBankAuditComponent } from "./equitasbankaudit/equitasbankaudit.component";
import { EquitasBankTransactionsComponent } from "./equitasbanktransactions/equitasbanktransaction.component";
import { EquitasBankService } from "./services/equitasbank.service";

import { IndusindBankAuditComponent } from "./indusindbankaudit/indusindbankaudit.component";
import { IndusindBankTransactionsComponent } from "./indusindbanktransactions/indusindbanktransaction.component";
import { IndusindBankService } from "./services/indusindbank.service";
import { EditIndusindBankTransactionDialog } from './indusindbanktransactions/edit-indusind-bank-transaction/edit-indusind-bank-transaction.component';

import { WithdrawBatchComponent } from "./withdraw-batch/withdrawbatch.component";

import { AutoWithdrawalComponent } from "./autowithdrawal/autowithdrawal.component";
import { AddAutoWithdrawal } from "./autowithdrawal/addautowithdrawal/addautowithdrawal.component";
import { AutoWithdrawService } from "./services/autowithdraw.service";
import { HypervergeKYCAuditComponent } from "./hypervergekycaudit/hypervergekycaudit.component";
import { PdfViewerComponent } from "./pdfviewer/pdfviewer.component";

import { SettlementComponent } from "./settlement/settlement.component";
import { SettlementService } from "./settlement/settlement.service";
import { LoginLogsComponent } from "./loginlogs/loginlogs.component";

import { EmailValidateAuditComponent } from "./emailvalidateaudit/emailvalidateaudit.component";
import { EmailValidateService } from "./services/emailvalidate.service";
import { ClientTransactionsComponent } from "./client-transactions/client-transactions.component";
import { AddEditDepositDialog } from "./client-transactions/add-deposit/add-deposit.component";
import { SentReceiveINRDialog } from "./client-transactions/sent-receive-inr/sent-receive-inr.component";
import { TransactionsReportComponent } from "./transactionsreport/transactionsreport.component";
import { PayoutComponent } from "./payout/payout.component";

@NgModule({
  declarations: [
    AppComponent,
    ApploginComponent,
    IndexComponent,
    AppcustomerlistComponent,
    AppkycdetailsComponent,
    TransactionsComponent,
    FiatTransactionsComponent,
    LoginactivityComponent,
    AdminTransactionsComponent,
    WithdrawComponent,
    FiatWithdrawComponent,
    OrderComponent,
    ManageadminComponent,
    GroupsComponent,
    SidebarComponent,
    HeaderComponent,
    ContentComponent,
    MobilesidebarComponent,
    AnnouncementComponent,
    TradereportComponent,
    SecuirtiesComponent,
    MenupermissionPipe,
    KycplansComponent,
    PayoutComponent,
    SumValuesPipe,
    TransferComponent,
    ConfirmationDialogComponent,
    ManageAuctionConfigurationComponent,
    AdmintradereportComponent,
    ManageipComponent,
    CmsComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    GeneratePasswordComponent,
    LinkexpireComponent,
    ManualkycComponent,
    ReferralconfigComponent,
    ReferalhistoryComponent,
    ReferralbonustransComponent,
    CareersComponent,
    ContentManagementComponent,
    CandidatesComponent,
    HomeComponent,
    ManageAddressWhitelistComponent,
    LedgerComponent,
    ClientOrderReportComponent,
    AdminTradeMasterReportComponent,
    EditAdminTradeMasterDialog,
    ClientTradeReportComponent,
    FireblockVaultComponent,
    ConfirmationDialogComponent,
    FireblockAuditComponent,
    ExchangeTradeReportComponent,
    PositionBookComponent,
    ClearJunctionAuditComponent,
    ProperJsonDialogComponent,
    whitelistedAddressComponent,
    depositAddressComponent,
    AddClientTrade,
    AddExchangeTrade,
    GetinTouchReportComponent,
    ClearJunctionTransactionsComponent,
    EditClearJTransactions,
    FireblockTransactionsComponent,
    FireblockSyncComponent,
    FiatWithdrawRejectDialog,
    FiatDepositConfirmDialog,
    ExchangeDepositComponent,
    ExchangeWithdrawalComponent,
    CustomerListComponent,
    AddEditCustomers,
    SidebarSubmenuComponent,
    AddEditSubmenuComponent,
    WalletComponent,
    BankComponent,
    AddBankDialog,
    AddEditAdminlist,
    MarketPricesComponent,
    CollateralDepositComponent,
    EditCollateralDepositDialog,
    MultiplierDialog,
    SumsubAuditComponent,
    ClientAssetReportComponent,
    AddExchangeWithdrawal,
    AMLBotAuditComponent,
    AddEditMarketPrice,
    EquitasBankAuditComponent,
    EquitasBankTransactionsComponent,
    IndusindBankAuditComponent,
    IndusindBankTransactionsComponent,
    WithdrawBatchComponent,
    EditIndusindBankTransactionDialog,
    AutoWithdrawalComponent,
    AddAutoWithdrawal,
    HypervergeKYCAuditComponent,
    PdfViewerComponent,
    SettlementComponent,
    EmailValidateAuditComponent,
    LoginLogsComponent,
    ClientTransactionsComponent,
    AddEditDepositDialog,
    SentReceiveINRDialog,
    TransactionsReportComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SimpleNotificationsModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    ClipboardModule,
    Ng2TelInputModule,
    AngularDateTimePickerModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    RichTextEditorAllModule,
    NgMultiSelectDropDownModule.forRoot(),
    MaterialModule,
    CKEditorModule,
    AngularMultiSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatCardModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    NgxJsonViewerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchsitekey,
      },
    },
    UserService,
    RoutingstateService,
    KycserviceService,
    PuserserviceService,
    AssetsService,
    PagerserviceService,
    WalletsService,
    TransactionService,
    BankService,
    ConfigurationService,
    ExchangeService,
    TradingService,
    AdminService,
    AnnouncementService,
    Globals,
    ReportService,
    FileService,
    ViewsService,
    CareerService,
    HomeService,
    ContentManagementService,
    AppKycDetailsService,
    AppCustomerService,
    ClientOrderService,
    FireblockService,
    ClearJunctionService,
    EquitasBankService,
    IndusindBankService,
    AutoWithdrawService,
    SettlementService,
    EmailValidateService
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    AddClientTrade,
    ProperJsonDialogComponent,
    AddExchangeTrade,
    EditClearJTransactions,
    FiatWithdrawRejectDialog,
    FiatDepositConfirmDialog,
    AddEditCustomers,
    AddEditMarketPrice,
    AddEditSubmenuComponent,
    AddEditAdminlist,
    EditCollateralDepositDialog,
    EditAdminTradeMasterDialog,
    MultiplierDialog,
    AddExchangeWithdrawal,
    AddBankDialog,
    EditIndusindBankTransactionDialog,
    AddAutoWithdrawal,
    PdfViewerComponent,
    AddEditDepositDialog,
    SentReceiveINRDialog
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts